// A sandbox launch must never fall back to the production values in .env.
// A new seed also needs fresh auth/checklists, otherwise browser state survives reset.
export function prepareSandbox(mode: string, url: string, run: string | undefined): void {
  if (mode !== "sandbox") return;
  if (url !== "http://127.0.0.1:55421" || !run) {
    throw new Error("Local sandbox is not configured. Run yarn sandbox:setup first.");
  }
  if (localStorage.getItem("bakery-sandbox-run") !== run) {
    for (const key of Object.keys(localStorage)) {
      if (
        key.startsWith("sb-") ||
        key.startsWith("baking:") ||
        key.startsWith("inquiry:submitted:")
      ) {
        localStorage.removeItem(key);
      }
    }
    localStorage.setItem("bakery-sandbox-run", run);
  }
  document.title = "[LOCAL TEST] Tastefull";
}
